

import XHeader from 'vux/src/components/x-header/index.vue'
import Alert from 'vux/src/components/alert/index.vue'


export default {
components: {
XHeader,
Alert
},
data () {
return {
showPwd:false,
fromUrl:"",
show: false,
inputType:'password',
message:"",
model:{mobile:"",password:""}
}
},
beforeRouteEnter (to, from, next) {
next(vm=>{          //  这里的vm指的就是vue实例，可以用来当做this使用
vm.fromUrl=from.path
})
},
methods: {
goBack(){

this.$router.push({
path : '/newindex',
query : {}
})
},
login:function(){
var self = this;
if(this.model.mobile == ""){
this.show=true ;
this.message="手机号码不能为空!";
return;
}

if(!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.model.mobile)){
this.show=true ;
this.message="手机号码格式不正确!";
return;
}

if(this.model.password == ""){
this.show=true ;
this.message="密码不能为空!";
return;
}


let rasPw = this.$getRsaCode(this.model.password);

this.$http.post(this.global.httpUrl + '/rest/v1/m/login',{mobile:this.model.mobile,password:rasPw},{emulateJSON:true}).then(function(res){
self.model.m_token=res.body.token;
if(res.body.success){
if(this.fromUrl=='/'){    // '/' 为直接访问登录
self.setUser(res.body.token,res.body.mobile);
self.$router.replace("/user/index");
}else if(this.fromUrl=='/auth/fotgetPassword'){
self.setUser(res.body.token,res.body.mobile);
self.$router.replace("/user/index");
}else if(this.fromUrl=='/auth/fotgetPassword2'){
self.setUser(res.body.token,res.body.mobile);
self.$router.replace("/user/index");
}else if(this.fromUrl=='/auth/register'){
self.setUser(res.body.token,res.body.mobile);
self.$router.replace("/user/index");
}else {
self.setUser(res.body.token,res.body.mobile);
self.$router.replace(this.fromUrl);
}

}else{
this.show=true ;
this.message=res.body.message;
}
},function(res){
console.log(res.status);
});
},
back:function(){

},
},

watch: {
showPwd(val) {
if(this.showPwd){
this.inputType = 'text'
}else{
this.inputType = 'password'
}
}
}
}



// WEBPACK FOOTER //
// ./src/views/auth/login.vue